(() => {
  const config = document.getElementById('tbm-mobile-ux');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const updateFocus = () => document.documentElement.classList.toggle('tbm-order-input-active', !!document.activeElement?.closest('.product__info-container input,.product__info-container textarea,.product__info-container select,.cart-items input'));
  document.addEventListener('focusin', updateFocus);
  document.addEventListener('focusout', () => requestAnimationFrame(updateFocus));
  let queued = false;
  const translate = () => {
    document.querySelectorAll('.gpo-app').forEach(app => {
      const walker = document.createTreeWalker(app, NodeFilter.SHOW_TEXT);
      const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        if (/Selections will add|to the price/.test(node.textContent)) node.textContent = node.textContent.replace('Selections will add',labels.surcharge_prefix).replace('to the price',labels.surcharge_suffix);
      });
    });
  };
  const observer = new MutationObserver(() => {
    if (queued) return; queued = true;
    requestAnimationFrame(() => { queued = false; observer.disconnect(); translate(); observer.observe(document.body,{childList:true,subtree:true,characterData:true}); });
  });
  translate(); observer.observe(document.body,{childList:true,subtree:true,characterData:true});
  window.addEventListener('pagehide',()=>observer.disconnect(),{once:true});
})();
